import { getBreadcrumbKind } from "ui/breadcrumbs/breadcrumbs.helpers";
import { type BreadcrumbItem, type BreadcrumbsProps } from "ui/breadcrumbs/breadcrumbs.types";

type UseBreadcrumbsProps = Pick<BreadcrumbsProps, "breadcrumbs">;

/** Keyed by position as well as label: a client can share its name with a page, as in "Campaigns". */
export const useBreadcrumbs = ({ breadcrumbs }: UseBreadcrumbsProps) => {
  const items: BreadcrumbItem[] = breadcrumbs.map(({ label, href = "", active }, index) => ({
    key: `${index}-${label}`,
    label,
    href,
    kind: getBreadcrumbKind({ href, active }),
  }));

  return { items };
};
